// Feedback never includes simulation inputs, results, saved scenarios or browser storage.
export async function sendFeedback(payload) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 15000);
  try {
    const response = await fetch('/api/feedback', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });
    const result = await response.json().catch(() => null);
    if (!response.ok || result?.ok !== true) {
      const error = new Error('Feedback delivery failed');
      error.code = response.status === 429 ? 'rate-limit' : response.status === 503 ? 'unavailable' : 'delivery';
      throw error;
    }
  } finally {
    clearTimeout(timeout);
  }
}
